module.exports = __webpack_public_path__ + "3fa6a663dac8f03cd69e33fd81809c29.png";